<style></style>
<!--  @click="modalShowEdit = true"  -->
<template>
	<errorContainer :error="erreur">
		<div>
			<div v-if="$screen.width <= 567">
				<h1 :class="[`${!$screen.sm ? 'main-page-title' : ''}`, { 'is-pwa': $isPwa() }]">
					{{ getTitle() }}
				</h1>
				<list-project-mobile
					@list-project-mobile:change-project="changeProject"
					@list-project-mobile:edit-project="openProjectWindow"
					@list-project-mobile:copy-invoice="copyInvoiceDetails"
					@list-project-mobile:add-project="modalShowCreate = true"
					@handle-change-check="handleChangeCheck"
				/>
			</div>
			<div v-else>
				<div class="animated fadeIn">
					<b-row align-h="center">
						<b-col md="12">
							<b-row>
								<b-col :cols="!isFilmSingle ? 12 : 8">
									<h1 :class="[`${!$screen.sm ? 'main-page-title' : ''}`, { 'is-pwa': $isPwa() }]">
										{{ getTitle() }}
									</h1>
								</b-col>
								<b-col v-if="isFilmSingle && !isFilmSingleFree" cols="4">
									<b-button class="float-right" @click="modalShowCreate = true">
										<i class="fa fa-plus" /> {{ FormMSG(62, 'Add project') }}
									</b-button>
								</b-col>
								<b-col v-if="isFilmSingle && isFilmSingleFree" cols="4">
									<div class="float-right">
										<subscription-dialog variantBtn="primary" icon="fa fa-plus" :btn-label="FormMSG(62, 'Add project')" />
									</div>
								</b-col>
							</b-row>
							<b-row>
								<b-col>
									<b-card>
										<h2>{{ getHeader() }}</h2>
										<div class="d-flex flex-column justify-content-start align-items-center w-100">
											<!-- <b-list-group class="w-100">
												<b-list-group-item
													v-for="(project, index) in myProjects"
													:key="project.id"
													action
													:active="myProject && myProject.id === project.id"
													@click="changeProject(project)"
												>
													<h5 class="mb-0 mt-3 pb-1">
														{{ project.titre }}
													</h5>
													<b-row>
														<b-col xl="6">
															<p class="">
																{{ project.production }}
															</p>
														</b-col>
														<b-col xl="6">
															<div class="float-right" style="margin-top: -18px">
																<b-button
																	v-if="myProject && myProject.id === project.id"
																	class="mr-3 btn-md hidden-sm"
																	variant="outline-light"
																	@click="copyInvoiceDetails(project.invoiceDetails)"
																>
																	<i class="icon-envelope-letter" />&nbsp;&nbsp;{{
																		FormMSG(23, 'Copy invoice details to clipboard...')
																	}}
																</b-button>
																<b-button
																	v-if="myProject && myProject.id === project.id && canEditProject()"
																	class="btn-md"
																	variant="outline-light"
																	@click="openProjectWindow"
																>
																	<div class="d-flex justify-content-start align-items-center">
																		<i class="fa fa-edit" style="font-size: 1.15rem" />&nbsp;&nbsp;
																		<div style="margin-top: 0px">{{ FormMSG(52, 'Edit') }}</div>
																	</div>
																</b-button>
																<b-form-checkbox
																	:id="`project-${project.id}`"
																	:name="`project-${project.id}`"
																	size="lg"
																	:value="true"
																	:unchecked-value="false"
																	class="project-checkbox"
																	@click.prevent.stop
																	@change="(value) => handleChangeCheck(value, index)"
																	switch
																/>
															</div>
														</b-col>
													</b-row>
												</b-list-group-item>
											</b-list-group> -->

											<div
												v-for="(project, index) in myProjects"
												:key="project.id"
												class="project-item"
												:class="{ active: myProject && myProject.id === project.id }"
											>
												<div class="project-item-content-start" @click="changeProject(project)">
													<h5 class="mb-0 mt-3 pb-1">
														{{ project.titre }}
													</h5>
													<div>
														<p>{{ project.production }}</p>
													</div>
												</div>
												<div class="project-item-content-end">
													<b-button
														v-if="myProject && myProject.id === project.id"
														class="mr-3 btn-md hidden-sm"
														variant="outline-light"
														@click.stop="copyInvoiceDetails(project.invoiceDetails)"
													>
														<i class="icon-envelope-letter"></i>
														&nbsp;&nbsp;{{ FormMSG(23, 'Copy invoice details to clipboard...') }}
													</b-button>

													<b-button
														v-if="myProject && myProject.id === project.id && canEditProject()"
														class="btn-md"
														variant="outline-light"
														@click.stop="openProjectWindow"
													>
														<div class="d-flex align-items-center">
															<i class="fa fa-edit" style="font-size: 1.15rem" />
															&nbsp;&nbsp;{{ FormMSG(52, 'Edit') }}
														</div>
													</b-button>
													<div v-if="isProduction && myProject && myProject.id !== project.id" class="project-group-checkbox">
														<div class="label-item">
															{{
																myProjects[index].isVisible
																	? FormMSG(102, 'Make unvisible this project')
																	: FormMSG(103, 'Make visible this project')
															}}
														</div>
														<div class="checkbox-item">
															<b-form-checkbox
																:id="`project-${project.id}`"
																size="lg"
																class="project-checkbox ml-3"
																switch
																v-model="myProjects[index].isVisible"
																v-tooltip.left="
																	myProjects[index].isVisible
																		? FormMSG(
																				104,
																				'Hide this project from users. It will no longer be visible in the project list'
																		  )
																		: FormMSG(
																				105,
																				'Make this project visible to users. It will appear in the project list.'
																		  )
																"
																@click.stop
																@change="(value) => handleChangeCheck(value, index)"
															/>
														</div>
													</div>
												</div>
											</div>
										</div>
									</b-card>
								</b-col>
							</b-row>
						</b-col>
					</b-row>
				</div>
			</div>
			<loading :active.sync="isLoading" :is-full-page="true"></loading>
			<b-modal
				size="xl"
				header-class="header-class-modal-doc-package"
				v-model="modalShowEdit"
				:title="FormMSG(55, 'Edit project')"
				:ok-title="FormMSG(51, 'Save')"
				:cancel-title="FormMSG(53, 'Cancel')"
				@ok.prevent="handleSubmitModalEditProject"
				@cancel.prevent="handleCloseModalEditProject"
				modal-class="mui-animation"
				:fade="false"
			>
				<ProjectForm :is-modal="true" :can-update="canUpdate" @updatefinishevent="onUpdateProjectFinished" />
			</b-modal>
			<b-modal
				size="xl"
				header-class="header-class-modal-doc-package"
				v-model="modalShowCreate"
				:title="FormMSG(56, 'Add project')"
				:ok-title="FormMSG(54, 'Add')"
				:cancel-title="FormMSG(53, 'Cancel')"
				hide-header-close
				no-close-on-backdrop
				no-close-on-esc
				@ok.prevent="handleSubmitModalCreateProject"
				@cancel.prevent="handleCloseModalCreateProtect"
				modal-class="mui-animation"
				:fade="false"
			>
				<ProjectForm
					project-form-id="0"
					:is-create-with-modal="true"
					:is-modal="true"
					:can-create="canCreate"
					:license-id="licenseId"
					@createfinishevent="onCreateProjectFinished"
				/>
			</b-modal>
		</div>
	</errorContainer>
</template>

<script>
import Loading from 'vue-loading-overlay';
import { store } from '@/store';
import languageMessages from '@/mixins/languageMessages';
import ProjectForm from './ProjectForm';
import isSingleProjectMixin from '@/mixins/isSingleProject.mixin';
import ListProjectMobile from '@/components/MyProjectMobile/ListProjectMobile';
import { myContracts } from '@/cruds/contract.crud';
import SubscriptionDialog from '@/components/InfoSheet/SubscriptionDialog.vue';
import GlobalMixin from '@/mixins/global.mixin';
import { mapGetters, mapActions } from 'vuex';
import { UpdateProjectVisibilty, changeProject as changeProjectService } from '@/cruds/project.crud';

export default {
	name: 'Myproject',
	components: {
		ProjectForm,
		ListProjectMobile,
		SubscriptionDialog,
		Loading
	},
	mixins: [languageMessages, isSingleProjectMixin, GlobalMixin],
	computed: {
		...mapGetters({
			isProduction: 'config/isProduction',
			myProject: 'config/myProject',
			myProjects: 'config/myProjects',
			isPme: 'config/isPme',
			isFilmSingleUserFree: 'config/isFilmSingleUserFree',
			isFilmSingleUser: 'config/isFilmSingleUser'
		})
	},
	data: () => {
		return {
			erreur: {},
			myerr: '',
			shared: store.state,
			modalShowEdit: false,
			modalShowCreate: false,
			canUpdate: false,
			canCreate: false,
			licenseId: null,
			isLoading: false
		};
	},
	mounted() {
		this.$nextTick(async () => {
			if (this.isFilmSingle) {
				this.licenseId = this.myProject.licenseID;
			}
			await this.getMyProjectsList();
		});
	},
	methods: {
		...mapActions({
			getMyProjectsList: 'config/getMyProjects',
			getNotifications: 'header/getNotifications',
			setProject: 'config/setProject'
		}),

		async handleChangeCheck(value, index) {
			try {
				this.isLoading = true;
				const item = this.myProjects[index];
				const projectId = +item.id;
				if (projectId) {
					await UpdateProjectVisibilty(projectId);
					await this.getMyProjectsList();
					const labelStatus = {
						true: this.FormMSG(2, 'Make visible projet with success'),
						false: this.FormMSG(3, 'Project successfully made invisible')
					}[value];
					this.createToastForMobile(this.FormMSG(4, 'Success'), labelStatus);
				}
			} catch (error) {
				console.error(error);
				this.createToastForMobile(this.FormMSG(5, 'Error'), this.FormMSG(6, 'Project visibility could not be updated'), '', 'danger');
				return error;
			} finally {
				this.isLoading = false;
			}
		},
		canEditProject() {
			// instead of isFilmSingle
			if (this.isFilmSingleUserFree || this.isFilmSingleUser) {
				return true;
			} else {
				return false;
			}
		},
		openProjectWindow() {
			this.$router.push('/settings');
		},
		getTitle() {
			if (this.isPme) {
				return this.FormMSG(110, 'My Office');
			}
			return this.FormMSG(10, 'My project');
		},
		getHeader() {
			if (this.isPme) {
				return this.FormMSG(111, ' What Legal Entity do you want to work on?');
			}
			return this.FormMSG(11, ' What project do you want to work on?');
		},
		copyInvoiceDetails(invoiceDetails) {
			var temp = document.createElement('textarea');
			var tempMsg = document.createTextNode(invoiceDetails);
			temp.appendChild(tempMsg);

			document.body.appendChild(temp);
			temp.select();
			document.execCommand('copy');
			document.body.removeChild(temp);
			console.log('Success!');
		},
		async changeProject(project) {
			try {
				this.isLoading = true;
				const visible = project.isVisible;
				if (visible) {
					const id = parseInt(project.id, 10);
					return await changeProjectService(id)
						.then(async (token) => {
							if (token) {
								await store.onNewToken(this.$apollo.provider.defaultClient, token);
								store.setProjectAction(project);
								const tmp = await myContracts();
								store.state.myContracts = tmp;
								this.myerr = '';
								await this.getNotifications(project.id);
								// window.location.reload();
							}
						})
						.catch((error) => {
							this.erreur = error;
						});
				} else {
					this.alertModal(
						this.FormMSG(100, 'Information'),
						this.FormMSG(101, 'You can’t access this project because it is not visible.'),
						this.FormMSG(15, 'Close'),
						'warning',
						'center'
					);
				}
			} catch (error) {
				console.error(error);
				return error;
			} finally {
				this.isLoading = false;
			}
		},
		handleSubmitModalEditProject() {
			this.canUpdate = true;
			//this.modalShowEdit = false
		},
		handleSubmitModalCreateProject() {
			this.canCreate = true;
		},
		onUpdateProjectFinished() {
			this.canUpdate = false;
			this.modalShowEdit = false;
			this.$toast({
				message: this.FormMSG(59, 'Update project successfull'),
				title: this.FormMSG(60, 'Success'),
				variant: 'success'
			});
		},
		async onCreateProjectFinished(payload) {
			this.canCreate = false;
			this.modalShowCreate = false;
			setProject(payload);
			await getListOfMyProjects();

			this.createToastForMobile(this.FormMSG(60, 'Success'), this.FormMSG(61, 'Create project successfull'));

			await this.changeProject(this.myProject);
		},
		handleCloseModalEditProject() {
			this.canUpdate = false;
			this.modalShowEdit = false;
		},
		handleCloseModalCreateProtect() {
			this.modalShowCreate = false;
		}
	}
};
</script>

<style lang="scss">
/* IE fix */
#card-chart-01,
#card-chart-02 {
	width: 100% !important;
}

.project-checkbox {
	cursor: pointer !important;
	input {
		cursor: pointer !important;
	}
	label {
		cursor: pointer !important;
	}
}

.project-item {
	display: flex;
	flex-direction: row;
	padding: 0.75rem 1.25rem;
	margin-bottom: -1px;
	background-color: #fff;
	border: 1px solid rgba(0, 0, 0, 0.125);
	width: 100%;
	&:hover {
		background-color: hsl(206, 96%, 90%);
		cursor: pointer;
	}
	&.active {
		color: #fff;
		background-color: #00a09c;
		border-color: #00a09c;
	}
	&-content-start {
		display: flex;
		flex-direction: column;
		width: 100%;
		flex: 1;
		gap: 0.5rem;
		cursor: pointer;
	}
	&-content-end {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-end;
		gap: 0.5rem;
	}
}

.project-group-checkbox {
	display: inline-flex;
	align-items: center;
	gap: 0.5rem;
	padding: 0.5rem 0.75rem;
	border-radius: 0.5rem;
	border: 2px solid #e5e7eb;
	background-color: #fff;
	transition: border-color 0.2s ease, box-shadow 0.2s ease;
	// max-width: 300px;
	width: 250px;
	.label-item {
		text-align: center;
		width: 80%;
	}
	.checkbox-item {
		width: 20%;
	}
	&:hover {
		border-color: #d1d5db;
	}

	&:focus-within {
		border-color: #0d6efd;
		box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.15);
	}
}
</style>
